var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:{
    'btns-bar__btn': true,
    'active-filter': _vm.active,
    'btns-bar__btn_right': _vm.isRight,
    'btns-bar__btn_left': _vm.isLeft,
  },on:{"click":_vm.onClick}},[_c('span',[_vm._v(_vm._s(_vm.$t(("filters." + _vm.filterName))))])])}
var staticRenderFns = []

export { render, staticRenderFns }